import { axiosInstance } from "./axios";
import { IGUSCompany } from "dto/IGUSCompany";
import useCustomQuery from 'hooks/useCustomQuery';

const queryKeys = {
    getCompanyFromNIP: (nip: string | number) => ['BIRService.getCompanyFromNIP', nip],
  };

const getCompanyFromNIP = async (nip: string | number): Promise<{ data: IGUSCompany }> => {
    return await axiosInstance.get(`/bir/search?nip=${nip}`)


}

const useGetCompanyFromNIP = (nip: string | number) => {
    return useCustomQuery(queryKeys.getCompanyFromNIP(nip), () => getCompanyFromNIP(nip), {
        enabled: false
    })
}

export default {
    useGetCompanyFromNIP
}